<template>
  <v-dialog v-model="showDialog" max-width="1000px">
    <v-card>
      <v-app-bar color="info" dark>
        <v-icon class="mr-2">fal fa-users-class</v-icon>
        <v-toolbar-title>Assignees</v-toolbar-title>
      </v-app-bar>
      <v-card-text>
        <v-data-table :headers="headers" :items="assignees">
          <template v-slot:item.dealership="{ item }">
            <span v-if="!isEmpty(item.specific_dealer)">
              {{ item.specific_dealer }}
            </span>
            <span v-else>
              {{ item.dealer }}
            </span>
          </template>
          <template v-slot:item.due_date="{ item }">
            {{ item.due_date | displayDateTime }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              @click="showUpdateDueDateDialog(item)"
              v-if="isAssignor(item)"
              color="blue"
              text
            >
              Update Due Date
            </v-btn>
            <v-btn
              @click="unassign(item)"
              v-if="isAssignor(item)"
              color="red"
              text
            >
              Unassign
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <update-due-date-dialog
      :refresh-table="getAssignedUsers"
    ></update-due-date-dialog>
  </v-dialog>
</template>

<script>
import { isEmpty as _isEmpty } from 'lodash-es';
import UpdateDueDateDialog from '@/components/playlist/UpdateDueDateDialog';

export default {
  name: 'AssignedUsers',
  components: { UpdateDueDateDialog },
  data() {
    return {
      loading: {
        table: false,
      },
      assignees: [],
      isEmpty: _isEmpty,
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Due Date',
          value: 'due_date',
        },
        {
          text: 'Dealership',
          value: 'dealership',
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
        },
      ],
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.$store.state.playlist.showAssigneesDialog;
      },
      set(value) {
        this.$store.dispatch('playlist/setShowAssigneesDialog', value);
      },
    },
  },
  watch: {
    showDialog(value) {
      if (value) {
        this.getAssignedUsers();
      }
    },
  },
  methods: {
    unassign(item) {
      this.$swal({
        title: 'Are you sure?',
        text: 'This action will unassign the playlist',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          this.unassignPlaylist(item);
        }
      });
    },
    unassignPlaylist(item) {
      this.$http
        .delete(`playlist/${item.playlist_id}/unassign`, {
          params: {
            userId: item.id,
            assignedBy: item.assigned_by,
          },
        })
        .then(({ data }) => {
          this.getAssignedUsers();
          this.$nextTick(() => {
            this.$notify('success', 'User unassigned!');
          });
        });
    },
    isAssignor(item) {
      // eslint-disable-next-line camelcase
      const { assigned_by } = item;
      // eslint-disable-next-line camelcase
      this.$store.dispatch('playlist/setSelectedAssignee', item);
      return assigned_by === this.$auth.user().id;
    },
    getAssignedUsers() {
      const { id } = this.$route.params;
      this.loading.table = true;
      this.axios
        .get(`playlist/${id}/assignees`)
        .then(({ data }) => {
          this.$nextTick(() => {
            this.assignees = data.assignees;
            this.loading.table = false;
          });
        })
        .catch(() => {
          this.loading.table = false;
        });
    },
    showUpdateDueDateDialog(assignee) {
      this.$store.dispatch('playlist/setSelectedAssignee', assignee);
      this.$store.dispatch('playlist/setShowUpdateDueDateDialog', true);
      console.log(assignee, this.$store.state.playlist.showUpdateDueDateDialog);
    },
  },
};
</script>

<style scoped></style>
